
import { useEffect, useRef, useState } from 'react';
import BlogPostCard from './BlogPostCard';

const posts = [
  {
    slug: 'prevent-water-damage',
    image: 'https://public.readdy.ai/ai/img_res/e9717219d832dbdc15bb3a6a7f3fb818.jpg',
    category: 'Prevention Tips',
    categoryIcon: 'ri-shield-check-line',
    title: '10 Ways to Prevent Water Damage in Your Home',
    excerpt:
      'With 1 in 60 homes filing a water damage claim each year at an average cost of $14,000, prevention is your best investment. Learn the essential steps every homeowner should take.',
    date: 'Jan 15, 2025',
    readTime: '8 min read',
  },
  {
    slug: 'water-leak-detection-systems',
    image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20installing%20a%20water%20leak%20detection%20sensor%20device%20near%20water%20heater%20in%20basement%20modern%20smart%20home%20technology%20clean%20organized%20utility%20room%20bright%20lighting&width=600&height=400&seq=blog2&orientation=landscape',
    category: 'Smart Home',
    categoryIcon: 'ri-sensor-line',
    title: 'Water Leak Detection Systems: A Complete Guide',
    excerpt:
      'Smart shut-off valves can reduce water damage costs by up to 90%. Discover how leak detection technology can protect your home and even lower your insurance premiums.',
    date: 'Jan 8, 2025',
    readTime: '10 min read',
  },
  {
    slug: 'winterizing-prevent-frozen-pipes',
    image: 'https://readdy.ai/api/search-image?query=Frozen%20pipe%20bursting%20with%20ice%20crystals%20forming%20on%20exterior%20home%20plumbing%20during%20winter%20cold%20weather%20damage%20prevention%20concept%20snowy%20background%20dramatic%20lighting&width=600&height=400&seq=blog3&orientation=landscape',
    category: 'Seasonal Care',
    categoryIcon: 'ri-snowy-line',
    title: 'Winterizing Your Home: Prevent Frozen Pipes',
    excerpt:
      'Roughly 250,000 U.S. homes suffer frozen pipe damage every year, with average claims exceeding $30,000. Here is how to protect your Utah home this winter.',
    date: 'Dec 20, 2024',
    readTime: '9 min read',
  },
];

export default function BlogList() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup observer on unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
      observer.disconnect();
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center mb-12 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">Latest Articles</h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-xl mx-auto">
            Expert guides to help you protect your home and respond to emergencies
          </p>
        </div>

        <div
          className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {posts.map((post) => (
            <BlogPostCard key={post.slug} {...post} />
          ))}
        </div>
      </div>
    </section>
  );
}
